import { useQuery } from 'react-query';
import axios from 'axios';
import {BillsDto} from "../models/bill";

export const getBills = async (): Promise<BillsDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}Bills`);
  return data;
};

const useInvoices = () => useQuery('bills', getBills);

export default useInvoices;
